import type {DateFormatter, Injector, LocalizeFunction, SanitizeHtmlFunction} from '../types';
import type {Logger} from '../logging/types';
import {getContext} from 'svelte';
import {
    CURRENT_LANGUAGE_KEY,
    DATE_FORMATTER_KEY,
    GLOBAL_EVENT_BUS_KEY,
    INJECTOR_KEY,
    LOCALIZE_KEY,
    LOGGER_KEY,
    SANITIZE_HTML_KEY,
    SERVER_URL_KEY
} from '../utils';

export function getLogger(): Logger | undefined {
    return getContext(LOGGER_KEY);
}

export function getLocalization(): LocalizeFunction {
    return getContext(LOCALIZE_KEY);
}

export function getDateFormatter(): DateFormatter {
    return getContext(DATE_FORMATTER_KEY);
}

export function getSanitize(): SanitizeHtmlFunction {
    return getContext(SANITIZE_HTML_KEY);
}

export function getInjector(): Injector {
    return getContext(INJECTOR_KEY);
}

export function getCurrentLanguage(): string {
    return getContext(CURRENT_LANGUAGE_KEY);
}

export function getServerUrl(): string {
    return getContext(SERVER_URL_KEY);
}

export function getGlobalEventBus(): EventTarget {
    return getContext(GLOBAL_EVENT_BUS_KEY);
}